import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import { ApiService } from '../../../services/index';
import { selectedCompanyStorage } from '../../../storage/company/selected-company.util';
import { SPACES_STALE_TIME_MS } from '../constants/spaces-query.const';
import { RecipientRoomView } from '../types/data-room.types';

const NO_ROOMS: RecipientRoomView[] = [];

/**
 * The rooms shared with this account, as Home draws them: a card each, with what the room holds.
 *
 * The navigation panel asks a route of its own — it needs the folders inside each room and none
 * of this. The owner's Home splits the same way, for the same reason: a tree and a list of cards
 * are two questions, and answering both in one payload makes the sidebar pay for the cards.
 *
 * Keyed by the company, because a recipient can hold rooms in more than one and the route answers
 * for the selected one.
 */
export const useRecipientRooms = ({ enabled }: { enabled: boolean }) => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isPending } = useAppQuery({
    enabled: enabled && !!companyId,
    queryFn: () => ApiService.get<RecipientRoomView[]>({ endpoint: BackendRoute.MY_DATA_ROOMS }),
    queryKey: [QueryKey.MY_DATA_ROOMS, companyId],
    staleTime: SPACES_STALE_TIME_MS,
  });

  return { isPending: enabled && isPending, rooms: data ?? NO_ROOMS };
};
